import type { UseFormRegister, UseFormSetValue } from 'react-hook-form'

export enum DeviceIdentifierTypeEnum {
  IMEI = 'imei',
  ORDER_ID = 'orderId',
  RETURN_CASE_ID = 'returnCaseId',
}

export enum PublicRequestReturnLabelStateEnum {
  LOADING = 'loading',
  FORM = 'form',
  SUBMITTING = 'submitting',
  SUCCESS = 'success',
}

export interface DeviceIdentifier {
  identifierType: DeviceIdentifierTypeEnum | ''
  value: string
}

export interface PublicRequestReturnLabelFormValues {
  devices: DeviceIdentifier[]
  contactName: string
  contactEmail: string
  companyName: string
  senderName: string
  street: string
  zipcode: string
  city: string
  country: { label: string; value: string } | null
}

export interface DeviceIdentifierBlockProps {
  index: number
  showRemove: boolean
  onRemove: () => void
  register: UseFormRegister<PublicRequestReturnLabelFormValues>
  setValue: UseFormSetValue<PublicRequestReturnLabelFormValues>
  selectedType: DeviceIdentifierTypeEnum | ''
}

export interface PublicRequestReturnLabelFormProps {
  hash?: string
  hashError?: boolean
  onHashRemove: () => void
  onSubmit: (data: PublicRequestReturnLabelFormValues) => void
}

export interface PublicRequestReturnLabelSuccessProps {
  trackingNumber: string
  onBackToHome: () => void
}
